import { ReactNode } from "react";

interface ValueCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export function ValueCard({ icon, title, description }: ValueCardProps) {
  return (
    <div className="group flex flex-col items-start gap-3 transition-all duration-300">
      {/* Icon and Title Container */}
      <div className="flex items-start gap-2.5 w-full">
        {/* Icon Container with enhanced styling */}
        <div className="flex p-2.5 items-center justify-center border border-gray-200 bg-[var(--color-tertiary)] flex-shrink-0 transition-all duration-300 group-hover:border-[var(--color-primary)] group-hover:scale-105 group-hover:shadow-[0_0_20px_rgba(145,124,102,0.15)]">
          <div className="transition-transform duration-300 group-hover:scale-110 text-[var(--color-secondary)]">
            {icon}
          </div>
        </div>
        
        {/* Title */}
        <h3 className="flex-1 text-[var(--color-secondary)] font-urbanist text-base md:text-lg font-semibold leading-[140%] transition-colors duration-300 group-hover:text-[var(--color-primary)]">
          {title}
        </h3>
      </div>
      
      {/* Description with improved typography */}
      <p className="text-[var(--color-secondary)]/70 font-urbanist text-xs md:text-sm font-medium leading-[150%] w-full transition-colors duration-300 group-hover:text-[var(--color-secondary)]">
        {description}
      </p>
    </div>
  );
}

